import { useCallback, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { api } from "@/api/client";

export interface OitResponse {
  token: string;
  expires_in: number;
}

export interface OitState {
  token: string;
  expires_in: number;
  generated_at: number; // Date.now() timestamp
}

export function useOit() {
  const [oitState, setOitState] = useState<OitState | null>(null);

  const { mutateAsync, isPending, isError } = useMutation({
    mutationFn: (projectSlug?: string) =>
      api<OitResponse>("/api/v2/auth/oit", {
        method: "POST",
        body: JSON.stringify({ project_slug: projectSlug ?? null }),
      }),
  });

  const generateOit = useCallback(
    async (projectSlug?: string) => {
      try {
        const data = await mutateAsync(projectSlug);
        const state: OitState = {
          token: data.token,
          expires_in: data.expires_in,
          generated_at: Date.now(),
        };
        setOitState(state);
        return state;
      } catch {
        return null;
      }
    },
    [mutateAsync],
  );

  return {
    generateOit,
    oitState,
    loading: isPending,
    error: isError ? "Failed to generate install token" : "",
  };
}
